var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("home.annunciation"),
                isShowFollow: false,
                visible: _vm.checkVisible,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.checkVisible = $event
                },
                open: _vm.opened,
              },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c("div", [
                _vm._v(
                  _vm._s(this.checkQuery && this.checkQuery.noticeContent)
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "class_pdf",
                  on: { click: _vm.downloadFileNoticePdf },
                },
                [
                  _vm._v(
                    _vm._s(
                      this.checkQuery &&
                        this.checkQuery.attachment &&
                        this.checkQuery.attachment.split("/").pop()
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    margin: "20px 0 0px 0",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-plain-primary",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.cancelButton")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-primary",
                      attrs: { plain: "" },
                      on: { click: _vm.handleSubmit },
                    },
                    [_vm._v(_vm._s(_vm.$t("home.sureButton")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }